/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Checkbox, InputContainer, Tooltip } from '@blend/enterprise-components';
import { camelCase } from '@utils/lodash';

const styles = StyleSheet.create({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
});

export const FilterCheckbox = ({
  isChecked,
  children: label,
  isDisabled,
  onChange,
  tooltip,
  name,
}: {
  isChecked: boolean;
  children: string;
  isDisabled?: boolean;
  onChange: (isChecked: boolean) => void;
  tooltip?: string;
  name?: string;
}): React.ReactElement => (
  <div className={css(styles.row)}>
    {/* Note that Tooltip just renders its children if empty */}
    <Tooltip position="left" text={tooltip} theme="dark">
      <InputContainer
        customComponentProps={{
          checked: isChecked,
          onChange: (event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.checked),
        }}
        disabled={isDisabled}
        input={{ id: `it-${camelCase(label)}Filter`, name: `${camelCase(name ?? label)}Filter` }}
        inputComponent={Checkbox}
        label={label}
        labelPosition="right"
        meta={{} as any}
      />
    </Tooltip>
  </div>
);
